/* eslint-disable prefer-promise-reject-errors */

import Swal from "sweetalert2";
import http from "./http-client";

const API_URL = process.env.REACT_APP_API_URL;
async function client(endpoint, payload) {
  const { data, headers, config, ...customConfig } = payload || {};

  const onSuccess = async (response) => {
    if (response.status === 200) {
      if (
        customConfig?.successMessage &&
        response?.data &&
        typeof response?.data === "string"
      ) {
        Swal.fire({
          icon: "warning",
          title: `<span style="font-size:1.5rem">Following request(s) failed.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${response?.data?.replaceAll(",", "</li><li>")}</li></ul>`,
        });
      } else if (customConfig?.successMessage) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: customConfig?.successMessage,
        });
      }
      return response;
    }
    return Promise.reject({ message: data?.message || response?.title });
  };

  const onFail = (error) => {
    if (error.status === 401) {
      sessionStorage.clear();
      window.top?.postMessage({ type: "logout" }, process.env.REACT_APP_ADMIN);
      return Promise.reject({ message: "Please re-authenticate." });
    }

    if (error.status === 409) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "The resource you are trying to add is already exist.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 403) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "You are not authorized to access this resource either due to access level or expired password, kindly contact support.",
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 404) {
      return Promise.reject({
        message: data?.message || error?.message || error?.title,
        status: error.status,
      });
    }

    if (error.status === 400) {
      if (error?.response?.data && typeof error?.response?.data === "string") {
        Swal.fire({
          icon: "warning",
          title: `<span style="font-size:1.5rem">Following request(s) failed.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${error?.response?.data?.replaceAll(",", "</li><li>")}</li></ul>`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.message || error?.title,
        });
      }

      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status,
      });
    }
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Something went wrong please try again.",
    });
    return Promise.reject({
      message: error?.message || error?.title,
      status: error.status,
    });
  };

  if (customConfig.method === "delete") {
    return http
      .delete(`${API_URL}/${endpoint}`, data || {}, config || {})
      .then(onSuccess)
      .catch(onFail);
  } else if (customConfig.method === "put") {
    return http
      .put(`${API_URL}/${endpoint}`, data, config || {})
      .then(onSuccess)
      .catch(onFail);
  } else if (data || customConfig.method === "post") {
    return http
      .post(
        `${API_URL}/${endpoint}`,
        data,
        headers ? { headers: { ...headers } } : {},
        config || {}
      )

      .then(onSuccess)
      .catch(onFail);
  }
  return http
    .get(`${API_URL}/${endpoint}`, config || {})
    .then(onSuccess)
    .catch(onFail);
}

export { client };
